module.exports = __webpack_public_path__ + "img/xiancaizhizaojijingjiagongjixie.81b11e33.jpg";